// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".React-select_select__h5iVI {\n  z-index: 1000;\n}\n\n.React-select_selectors__xum3M {\n  display: flex;\n  gap: 30px;\n}", "",{"version":3,"sources":["webpack://./src/components/Selectors/React-Select/React-select.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF","sourcesContent":[".select {\n  z-index: 1000;\n}\n\n.selectors{\n  display: flex;\n  gap: 30px\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": "React-select_select__h5iVI",
	"selectors": "React-select_selectors__xum3M"
};
export default ___CSS_LOADER_EXPORT___;
